var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgRing = function SvgRing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/notification/grey",
    className: "fill-colored-element",
    fill: "#C1C1C1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "20x20-copy",
    transform: "translate(7 6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0a6 6 0 016 6v1.892a4 4 0 00.57 2.058l.93 1.55a1.65 1.65 0 01-1.415 2.5H1.915A1.65 1.65 0 01.5 11.5l.93-1.55A4 4 0 002 7.892V6a6 6 0 016-6z",
    id: "Path-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 15v.003a3 3 0 006 0V15",
    id: "Path-3"
  }))))));
};
export default SvgRing;